<template>
    <div v-if="banner_config.status == 'A'" class='banner'>
        <div class="glide" id='banner_message_slider'>
            <div class="glide__track" data-glide-el="track">
                <ul class="glide__slides">
                    <div v-for="banner_message in banner_config.banner_messages" :key='banner_message'>
                        <li class="glide__slide"> 
                            <a class='link' :href="banner_message.url" @click='openUrl($event, banner_message.url)'>
                                {{banner_message.message}}
                            </a>
                        </li>
                    </div>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import "@glidejs/glide/dist/css/glide.core.css";
import "@glidejs/glide/dist/css/glide.theme.css";
import Glide from '@glidejs/glide';
import {checkAuth} from "@/global/modules/functions.js";

export default {
    data(){
        return{
            glide_instance_banner: null,
            banner_config: [],
            mobile_mode: false,
            screen_size_check_timeout: null,
        }
    },
    methods: {
        openUrl(e, url) {
            if(e.ctrlKey) {
                return;
            } else {
                e.preventDefault();
                this.$router.push(url);
            }
        },
        setBannerMessages(){
            setTimeout(() => {
                    if(document.getElementById('banner_message_slider') != null){
                        this.glide_instance_banner = new Glide('#banner_message_slider',{type: 'carousel',
                            perView: 1, 
                            keyboard: false, 
                            autoplay: '5000', 
                            dragThreshold: false, 
                            animationDuration: 1500,
                            animationTimingFunc: 'ease-in-out'
                        }).mount();
                        // Ensure update only happens after mount
                        this.updateGlideInstance();
                    }
            }, 1);
        },
        async getBannerConfig() {
            let response = await fetch(`/api/banner-config`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.banner_config   = results.banner_config;
                if(this.banner_config.banner_messages.length > 0) {
                    this.setBannerMessages();
                    setTimeout(() => this.CheckMobileMode(), 1);
                }
                
            }
        },
        CheckMobileMode(){
            let canvas = document.getElementsByClassName('banner')[0];
            if(typeof canvas !== 'undefined'){
                new ResizeObserver(()=>{
                    clearTimeout(this.screen_size_check_timeout);

                    this.screen_size_check_timeout = setTimeout(() => { //Set timeout to stop ResizeObserver loop completed with undelivered notifications error
                        if(canvas.clientWidth <= 768){
                            this.mobile_mode = true;
                        }
                        else{
                            this.mobile_mode = false;
                        }
                        this.updateGlideInstance();
                    }, 1);
                }).observe(canvas);
            }
        },
        updateGlideInstance() {
            if (!this.banner_config.is_animated && !this.mobile_mode) {
                this.glide_instance_banner.update({
                    perView: this.banner_config.banner_messages.length,
                    autoplay: null, 
                });
            } else{
                this.glide_instance_banner.update({
                    perView: 1,
                    autoplay: '5000', 
                });
            }
        }
    },
    mounted(){
        this.getBannerConfig();
    }
}
</script>

<style lang="scss" scoped>
.banner{
    background-color: var(--black);
    color: white;
    text-align: center;
    font-size: 0.8rem;
    height: var(--banner-height);
    padding-top: 9px;
    box-sizing: border-box;
    
    @media(max-width: 768px){
       padding-top: 5px;
       padding-bottom: 5px;
       height: auto;
    }
}
.link{
    text-decoration: none;
    color: inherit;
}

.glide * {
    cursor: pointer;
}

.static-banner{
    display: flex;
    flex-wrap: wrap;
    margin-left: -15px;
    margin-right: -15px;
    align-items: center;
    justify-content: center;
}
.banner_message{
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
}
</style>